import { useEffect, useReducer } from "react";
import { useLocation } from "react-router-dom";
import { updateTaskService } from "services/task";

const initialArgs = {
    currentSelectedTask: null
};

const reducer = (state: any, action: any) => {
    return { ...state, ...action };
};

const useTaskHook = () => {
    const [state, setState] = useReducer(reducer, initialArgs);
    const location = useLocation();

    const resetStateToDefaults = () => {
        setState({ ...initialArgs })
    }

    const updateTask = async (eventId: any, data: any) => {
        await updateTaskService(eventId, data);
    }

    useEffect(() => {
        resetStateToDefaults();
    }, [location.pathname]);

    return {
        updateTask,
        setState,
        ...state
    }
}

export default useTaskHook;